import React, { useState } from "react";
import indexer from "./types";
import {
  required,
  isValidRegex,
  grtrThanEqTo,
  lessThanEqTo,
} from "../../utils/validation";
import { integerExp, alphaNumExp } from "../../utils/regex";

export interface IListObj {
  value: number | string;
  display: number | string;
}

export interface ISElectDropdownProps {
  className?: string;
  placeholderClassName: string;
  errorText?: string | null;
  defaultValue?: string;
  lable?: boolean;
  placeholder?: string;
  required?: boolean;
  id?: string;
  type?: string;
  name?: string;
  disabled?: boolean;
  selected?: boolean;
  selectedValue?: number | string;
  value?: string;
  dropdownOptions: Array<IListObj>;
  //  onSelect: (id: string | number) => void;
  options?: any;
  downarrow?: string;
  autoComplete?: "on" | "off";
  onChange?: (value: string) => string | void;
  onChangeEvent?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (
    error: indexer,
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => void;
  onMouseOut?: (value: string) => string | void;
}

const SelectDropdown: React.FC<ISElectDropdownProps> = (props) => {
  const [selectOption, setselectOption] = useState<Array<IListObj>>();
  const [value, setValue] = React.useState(props.defaultValue || "");

  // const handleMouseOut = (e: any) => {
  //     if (props.onMouseOut) {
  //       e.currentTarget.blur();
  //       props.onMouseOut(e.target.value);
  //     }
  //   };
  function isRequired(value: any): boolean {
    return !props.required || (props.required && !!required(value));
  }
  function handleBlur(e: React.ChangeEvent<HTMLSelectElement>) {
    setFocusClass("");

    let errorObj: indexer = {};

    if (props.required) {
      errorObj = { ...errorObj, required: isRequired(value) };
    }

    props?.onBlur(errorObj, e);
  }

  React.useEffect(() => {
    if (props.defaultValue !== undefined && value !== props.defaultValue) {
      setValue(props.defaultValue);
    }
  }, [props.defaultValue]);

  const [focusClass, setFocusClass] = React.useState("");

  return (
    <div className="col">
      <div className={props.className}>
        <div
          className={
            props.placeholderClassName +
            (props.errorText ? " error" : focusClass)
          }
        >
          {value === "" && props.lable && (
            <>
              <label htmlFor={props.id}>{props.placeholder}</label>
              {props.required && <span className="star">*</span>}
            </>
          )}
        </div>
        {
          <select
            className="form-control"
            defaultValue={value}
            id={props.id}
            name={props.name}
            onChange={props.onChangeEvent}
            onFocus={() => setFocusClass(" focus")}
            required={props.required}
            //    onMouseOut={handleMouseOut}
            onBlur={(e) => handleBlur(e)}
          >
            {props.dropdownOptions.map((option, index) =>
              option.value ? (
                <option key={index} value={option.value}>
                  {option.display}
                </option>
              ) : (
                <></>
              ),
            )}
          </select>
        }
        <span className={props.downarrow}></span>
      </div>
    </div>
  );
};
export default SelectDropdown;
